export enum IdentifierType {
  AADHAR = "AADHAR",
  PAN = "PAN",
  EMAIL = "EMAIL",
  DOB = "DOB",
  ACCNO = "ACCNO",
  CRN = "CRN",
  PPAN = "PPAN",
  OTHER = "OTHER",
}

export enum StrongIdentifier {
  MOBILE = "MOBILE",
}

export enum IdentifierCategory {
  STRONG = "STRONG",
  WEAK = "WEAK",
  ANCILLARY = "ANCILLARY",
}
